import { render, staticRenderFns } from "./EditAnswerModal.vue?vue&type=template&id=2794f83f"
import script from "./EditAnswerModal.vue?vue&type=script&lang=js"
export * from "./EditAnswerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports